// react components
import React, {
    useEffect,
} from 'react'
import {
    useSelector,
} from 'react-redux'

// data
import {
    defaultReduxState,
} from 'data'

// main
export const WidgetSite: React.FC = () => {

    const reduxCacheSiteportfolioid = useSelector((state: defaultReduxState) => state.reduxCacheSite.portfolio?.id)

    if (reduxCacheSiteportfolioid === 688) {
        return <WidgetHelper />
    }
    return null

}

const WidgetHelper: React.FC = () => {

    useEffect(() => {
        const options = {
            whatsapp: "+33661967119",
            call_to_action: "Discutons sur WhatsApp",
            position: "right",
        }

        const proto = document.location.protocol
        const host = "getbutton.io"
        const url = `${proto}//static.${host}`

        const script = document.createElement('script')
        script.type = 'text/javascript'
        script.async = true
        script.src = `${url}/widget-send-button/js/init.js`

        script.onload = () => {
            // @ts-ignore
            if (window.WhWidgetSendButton) {
                // @ts-ignore
                window.WhWidgetSendButton.init(host, proto, options)
            }
        }

        document.body.appendChild(script)

        // Optional: cleanup if component unmounts
        return () => {
            document.body.removeChild(script)
        }
    }, [])

    return null
}
